import { render, staticRenderFns } from "./WSUTable.vue?vue&type=template&id=2df8c327&scoped=true&"
import script from "./WSUTable.vue?vue&type=script&lang=js&"
export * from "./WSUTable.vue?vue&type=script&lang=js&"
import style0 from "./WSUTable.vue?vue&type=style&index=0&id=2df8c327&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df8c327",
  null
  
)

export default component.exports